import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-showerrordialog',
  templateUrl: './showerrordialog.component.html',
  styleUrls: ['./showerrordialog.component.scss']
})
export class ShowerrordialogComponent implements OnInit {
  errors: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.errors = data;
  }

  ngOnInit() {
  }

}
